import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-patients-icon',
    templateUrl: './patients.component.svg',
    styleUrls: ['./patients.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PatientsComponent {}
